import api from "./api";
import ApiBase from "./apiBase";

const groupsApi = new ApiBase("/accounts/customer_groups");

export default groupsApi;

